module.exports = __webpack_public_path__ + "static/media/middle-right-4.58c01d66.png";